import { disableScroll } from "../functions/disable-scroll.js";
import { enableScroll } from "../functions/enable-scroll.js";

export default function burgerInit() {
  document.addEventListener("DOMContentLoaded", () => {
    const burger = document.querySelector(".burger");
    const burgerBody = document.querySelector(".burger-menu");
    const links = document.querySelectorAll(".burger-menu a");

    burger.addEventListener("click", () => {
      burger.classList.toggle("active");
      burgerBody.classList.toggle("active");

      if (burger.classList.contains("active")) {
        burger?.setAttribute("aria-expanded", "true");
        burger?.setAttribute("aria-label", "Закрыть меню");
        disableScroll();
      } else {
        burger?.setAttribute("aria-expanded", "false");
        burger?.setAttribute("aria-label", "Открыть меню");
        enableScroll();
      }
    });

    links.forEach((link) => {
      link.addEventListener("click", () => {
        burger.classList.toggle("active");
        burgerBody.classList.toggle("active");
        if (burger.classList.contains("active")) {
          burger?.setAttribute("aria-expanded", "true");
          burger?.setAttribute("aria-label", "Закрыть меню");
          disableScroll();
        } else {
          burger?.setAttribute("aria-expanded", "false");
          burger?.setAttribute("aria-label", "Открыть меню");
          enableScroll();
        }
      });
    });
  });
}
